import React from "react";

function EmptyMailbox() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 60 60"
    >
      <path
        fill="#7a3939"
        d="M27 40v17a2 2 0 01-2 2h-6a2 2 0 01-2-2V40z"
        data-original="#7a3939"
      ></path>
      <path
        fill="#ea3d53"
        d="M37 12H10a9 9 0 00-9 9v17h36z"
        data-original="#ea3d53"
      ></path>
      <path
        fill="#ce2c47"
        d="M46 21v17H28V21a9 9 0 0118 0z"
        data-original="#ce2c47"
      ></path>
      <path
        fill="#edc726"
        d="M12 2h9a1 1 0 011 1v4a1 1 0 01-1 1h-9z"
        data-original="#edc726"
      ></path>
      <path
        fill="#ce2c47"
        d="M14 16.41a5 5 0 11-4 0z"
        data-original="#ce2c47"
      ></path>
      <path
        fill="#af2240"
        d="M1 37h56a2 2 0 012 2 2 2 0 01-2 2H3a2 2 0 01-2-2v-2z"
        data-original="#af2240"
      ></path>
      <path
        fill="#7a3939"
        d="M11 1h2a1 1 0 011 1v18a2 2 0 01-2 2 2 2 0 01-2-2V2a1 1 0 011-1z"
        data-original="#7a3939"
      ></path>
    </svg>
  );
}

export default EmptyMailbox;